import { apiFetch } from './api'

export async function generateTeamLogo({ name, description, mcaptchaToken }) {
  const payload = { name, description }
  if (mcaptchaToken) payload.mcaptchaToken = mcaptchaToken
  return apiFetch('/Ai/generate-logo', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function polishText({ scope, text }) {
  return apiFetch('/Ai/polish-text', {
    method: 'POST',
    body: JSON.stringify({ scope, text }),
  })
}

export async function executeCommand({ command }) {
  return apiFetch('/Ai/command', {
    method: 'POST',
    body: JSON.stringify({ command }),
  })
}

/**
 * AI解析对局截图
 * @param {string} imageBase64 - Base64编码的图片数据
 * @returns {Promise<{
 *   success: boolean,
 *   message?: string,
 *   mapName?: string,
 *   regulator?: {
 *     roleName: string,
 *     score: number,
 *     terrorShockCount: number,
 *     downCount: number,
 *     hitSurvivorCount: number,
 *     palletDestroyCount: number
 *   },
 *   survivors?: Array<{
 *     roleName: string,
 *     score: number,
 *     kiteTime: number,
 *     rescueCount: number,
 *     decodeProgress: number,
 *     palletStunCount: number
 *   }>,
 *   rawJson?: string
 * }>}
 */
export async function parseGameRecordImage(imageBase64) {
  return apiFetch('/Ai/parse-game-record-image', {
    method: 'POST',
    body: JSON.stringify({ imageBase64 }),
  })
}

/**
 * AI设计赛程方案（简单版）
 * @param {number} teamCount - 队伍数量
 * @param {string} requirements - 用户需求描述
 * @returns {Promise<{
 *   format: string,
 *   bestOf: number,
 *   groupSize?: number,
 *   advancePerGroup?: number,
 *   swissRounds?: number,
 *   intervalMinutes: number,
 *   maxMatchesPerDay?: number,
 *   estimatedMatches: number,
 *   estimatedDays: number,
 *   explanation: string,
 *   stages: string[]
 * }>}
 */
export async function designBracket({ teamCount, requirements }) {
  return apiFetch('/Ai/design-bracket', {
    method: 'POST',
    body: JSON.stringify({ teamCount, requirements }),
  })
}

/**
 * AI完整设计赛程流程图
 * @param {number} teamCount - 队伍数量
 * @param {string} requirements - 用户需求描述
 * @returns {Promise<{
 *   nodes: Array<{
 *     id: string,
 *     type: string,
 *     name: string,
 *     format?: string,
 *     icon: string,
 *     color: string,
 *     positionX: number,
 *     positionY: number,
 *     width: number,
 *     height: number,
 *     config?: object,
 *     inputPorts: Array<{id: string, name: string, type: string, color: string}>,
 *     outputPorts: Array<{id: string, name: string, type: string, color: string}>
 *   }>,
 *   connections: Array<{
 *     id: string,
 *     sourceNodeId: string,
 *     sourcePortId: string,
 *     targetNodeId: string,
 *     targetPortId: string,
 *     label?: string,
 *     color: string
 *   }>,
 *   explanation: string,
 *   estimatedMatches: number,
 *   estimatedDays: number
 * }>}
 */
export async function designStageFlow({ teamCount, requirements }) {
  return apiFetch('/Ai/design-stage-flow', {
    method: 'POST',
    body: JSON.stringify({ teamCount, requirements }),
  })
}

export default { generateTeamLogo, polishText, executeCommand, designBracket, designStageFlow, parseGameRecordImage }
